var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgChargebee = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F30",
    d: "M14.603 20.002 36 14.804V3.5H24.905z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F30",
    d: "M4 19.803a16.6 16.6 0 0 0 .468 3.923l10.136-3.724-10.22-3.757A16.8 16.8 0 0 0 4 19.8v.002Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F30",
    d: "m7.768 9.294 6.832 10.71 3.15-16.342A15.9 15.9 0 0 0 7.768 9.3zm6.835 10.708L36 25.197V36.5H24.905z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F30",
    d: "m7.77 30.708 6.83-10.711 3.146 16.338a15.9 15.9 0 0 1-9.98-5.637l.003.01Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgChargebee);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/chargebee.1593cf7c.svg";